import type { EventTierAnalyticsDbFilters } from "./types";

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

export type AnalyticsCreatedAt =
  | { mode: "unbounded" }
  | { mode: "bounded"; createdAt: { gte?: Date; lt?: Date } }
  | { mode: "match-none" };

export function analyticsCreatedAt(
  filters: EventTierAnalyticsDbFilters
): AnalyticsCreatedAt {
  if (filters.dateRange === "24h") {
    return {
      mode: "bounded",
      createdAt: { gte: new Date(Date.now() - 24 * 60 * 60 * 1000) },
    };
  }
  if (filters.dateRange === "7d") {
    return {
      mode: "bounded",
      createdAt: { gte: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000) },
    };
  }
  if (filters.dateRange === "30d") {
    return {
      mode: "bounded",
      createdAt: { gte: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000) },
    };
  }
  if (filters.dateRange === "custom") {
    const fromDate = filters.fromDate?.trim() ?? "";
    const toDate = filters.toDate?.trim() ?? "";
    if (!DATE_ONLY.test(fromDate) || !DATE_ONLY.test(toDate)) {
      return { mode: "match-none" };
    }
    const gte = new Date(`${fromDate}T00:00:00.000Z`);
    const lt = new Date(`${toDate}T00:00:00.000Z`);
    lt.setUTCDate(lt.getUTCDate() + 1);
    return { mode: "bounded", createdAt: { gte, lt } };
  }
  return { mode: "unbounded" };
}

export function withCreatedAt<T extends Record<string, unknown>>(
  where: T,
  range: Extract<AnalyticsCreatedAt, { mode: "bounded" | "unbounded" }>
): T {
  if (range.mode === "bounded") {
    return { ...where, createdAt: range.createdAt };
  }
  return where;
}
